import { GlobalModule } from '@/shared';

export default GlobalModule;
